// Terms of Service - Estonian version

export const termsContentET = {
  sections: [
    { id: 'general', title: '1. Üldsätted' },
    { id: 'services', title: '2. Teenuste ese ja vastuvõtmine' },
    { id: 'reporting', title: '3. Hindamine, aruandlus ja tulemus' },
    { id: 'payment', title: '4. Makse ja viivised' },
    { id: 'obligations', title: '5. Poolte õigused ja kohustused' },
    { id: 'ip', title: '6. Intellektuaalne omand' },
    { id: 'confidentiality', title: '7. Konfidentsiaalsus ja andmetöötlus' },
    { id: 'liability', title: '8. Maksed, tagasimaksed ja vastutus' },
    { id: 'termination', title: '9. Kehtivusaeg, lõpetamine ja tagajärjed' },
    { id: 'force-majeure', title: '10. Vääramatu jõud' },
    { id: 'disputes', title: '11. Vaidluste lahendamine ja kohaldatav õigus' },
    { id: 'other', title: '12. Muud sätted' }
  ],
  
  general: {
    title: '1. Üldsätted',
    content: [
      { num: '1.1', text: 'Käesolevad Tingimused reguleerivad Polyus Plus OÜ (edaspidi "Täitja") ja kliendi (edaspidi "Klient") vahelisi teenuste osutamise kordi vastavalt sõlmitud lepingule, tellimisele või tasutud arvele (edaspidi "Leping").' },
      { num: '1.2', text: 'Arve tasumise või Lepingu allkirjastamisega kinnitab Klient, et on Tingimustega tutvunud ja nõustub nendega täielikult.' },
      { num: '1.3', text: 'Täitja osutab konsultatsiooni-, automatiseerimis-, AI-, BI- ja muid seotud teenuseid vastavalt veebisaidi kirjeldusele ja/või Lepingule. Klient kohustub teenuseid tasuma ja vajalikku teavet ning juurdepääse andma.' },
      { num: '1.4', text: 'Käesolevaid Tingimusi kohaldatakse üksnes juriidiliste isikute ja/või füüsilisest isikust ettevõtjate (FIE) vaheliste tehingute (B2B) suhtes. Tarbijakaitseseadust ei kohaldata.' },
      { num: '1.5', text: 'Keeleversioonide vastuolude korral on eelistatud eestikeelne versioon.' }
    ]
  },
  
  services: {
    title: '2. Teenuste ese ja vastuvõtmine',
    content: [
      { num: '2.1', text: 'Täitja osutab teenuseid vastavalt valitud paketile (nt INSIGHT, GROWTH ENGINE, AI TRANSFORM, PROJECT+). Klient kohustub teenuseid tasuma ja tegema koostööd (andmete, juurdepääsude, kooskõlastuste andmine).' },
      { num: '2.2', text: 'Maht ja tähtajad on määratud Lepingus. Teabe või juurdepääsu andmise viivituse korral on Täitjal õigus tähtaegu muuta.' },
      { num: '2.3', text: 'Täitjal on õigus oma äranägemise järgi muuta teenuste osutamise meetodeid ja vahendeid, kui see ei halvenda kokkulepitud tulemust.' },
      { num: '2.4', text: 'Vastuvõtmine: Klient kontrollib üleantud tulemusi 3 (kolme) tööpäeva jooksul ja saadab kirjalikud märkused e-posti teel. Nende puudumisel loetakse tulemused vaikimisi vastu võetuks. Tulemuste tegelik kasutamine Kliendi poolt võrdub nende vastuvõtmisega.', highlight: true },
      { num: '2.5', text: 'Muudatused (Change Request): Kõik nõuete või mahu muudatused vormistatakse kirjalikult (e-posti teel), tasutakse eraldi ja toovad kaasa vastava tähtaegade korrigeerimise.', highlight: true },
      { num: '2.6', text: 'Täitjal on õigus tähtaegu ja maksumust korrigeerida, kui Kliendi poolsed andmete viivitused või puudulikkus toovad kaasa seisaku või lisatingimusi.' }
    ]
  },
  
  reporting: {
    title: '3. Hindamine, aruandlus ja tulemus',
    content: [
      { num: '3.1', text: 'Täitja fikseerib KPI näitajad ja kokkuleppel ka ROI mõõdikud.' },
      { num: '3.2', text: 'Klient tunnistab, et tulemus sõltub lähtandmetest, Kliendi enda otsustest ja tegevustest. Täitja ei garanteeri konkreetset ärilist tulemust.' },
      { num: '3.3', text: 'Täitja ei vastuta kasumi kaotuse, andmete, maine ega mingisuguste kaudsete kahjude eest.' },
      { num: '3.4', text: 'Kõik prognoosid, analüütilised järeldused ja arvutused on hinnangulised ega ole tulemuste garantii.' }
    ]
  },
  
  payment: {
    title: '4. Makse ja viivised',
    content: [
      { num: '4.1', text: 'Teenuste maksumus on märgitud veebisaidil ja/või Lepingus.' },
      { num: '4.2', text: 'Osaline ettemaks on lubatud, kui see on Lepingus märgitud.' },
      { num: '4.3', text: 'Iga makse viivituse päeva eest arvestatakse viivismaksu 0,05% tasumata summalt kuni täieliku tasumise päevani kaasa arvatud.', penalty: '0,05 %' },
      { num: '4.4', text: 'Täitjal on õigus teenuste osutamine peatada, kui makse viibib rohkem kui 5 kalendripäeva.' },
      { num: '4.5', text: 'Kliendil ei ole õigust makseid kinni pidada või tasaarvestusi teha ilma Täitja kirjaliku nõusolekuta.' },
      { num: '4.6', text: 'Täitjal on õigus oma äranägemise järgi võtta tasu tööde taaskäivitamise ja ressursside ümberjaotamise eest, teavitades Klienti eelnevalt.' },
      { num: '4.7', text: 'Kõik hinnad on märgitud ilma käibemaksuta, kui pole teisiti märgitud.' },
      { num: '4.8', text: 'Klient hüvitab mõistlikud kulud, mis on seotud võlgnevuse sissenõudmisega.' }
    ]
  },
  
  obligations: {
    title: '5. Poolte õigused ja kohustused',
    content: [
      { num: '5.1', text: 'Klient on kohustatud andma usaldusväärset teavet, tagama juurdepääsu ja vajalikku koostööd.' },
      { num: '5.2', text: 'Täitja täidab teenuseid professionaalse hoolsusega ja teavitab Klienti tööde käigust.' },
      { num: '5.3', text: 'Klient vastutab oma tegevuse vastavuse eest seadusandlusele (sealhulgas GDPR, töö- ja maksuõigus).' },
      { num: '5.4', text: 'Täitjal on õigus kaasata alltöövõtjaid, jäädes vastutavaks tulemuse eest.' },
      { num: '5.5', text: 'Täitja ei vastuta teenuste mittetäitmise eest, kui Klient ei ole andnud vajalikke andmeid või juurdepääsu.' },
      { num: '5.6', text: 'Kui teenused kasutavad väliseid platvorme või API-sid (nt AI teenused), vastutab Klient maksmise ja seadusliku kasutamise eest. Täitja ei vastuta nende teenuste tõrgete, kättesaamatuse või hinnamuudatuste eest.' }
    ]
  },
  
  ip: {
    title: '6. Intellektuaalne omand',
    content: [
      { num: '6.1', text: 'Kõik Täitja poolt väljatöötatud materjalid (aruanded, skriptid, mallid jne) jäävad tema omandiks kuni täieliku tasumiseni.' },
      { num: '6.2', text: 'Pärast täielikku tasumist saab Klient mitteeksklusiivse, tähtajatu, edasi mitteantava litsentsi materjalide sisemiseks kasutamiseks. Kolmandatele osapooltele edastamine ja alilitsentsimine on keelatud.' },
      { num: '6.3', text: 'Täitjal on õigus kasutada anonüümistatud või üldistatud näiteid (case study) oma portfoolios ja turundusmaterjalides. Klient võib saata kirjaliku vastuväite e-posti teel.' },
      { num: '6.4', text: 'Kliendil ei ole õigust materjale muuta, dekompileerida või kasutada sarnaste teenuste osutamiseks kolmandatele osapooltele.' },
      { num: '6.5', text: 'Kõik selgesõnaliselt edasi mitteantud intellektuaalse omandi õigused jäävad Täitjale.' }
    ]
  },
  
  confidentiality: {
    title: '7. Konfidentsiaalsus ja andmetöötlus',
    content: [
      { num: '7.1', text: 'Pooled kohustuvad konfidentsiaalset teavet mitte avaldama, välja arvatud seadusega ette nähtud juhtudel.' },
      { num: '7.2', text: 'Konfidentsiaalsuskohustus jääb kehtima 3 aastat pärast teenuste lõpetamist.' },
      { num: '7.3', text: 'Täitjal on õigus teavet avaldada oma konsultantidele ja töövõtjatele tingimusel, et nad järgivad konfidentsiaalsust.' },
      { num: '7.4', text: 'Kliendi isikuandmete töötlemisel tegutseb Täitja andmetöötlejana (data processor) vastavalt GDPR-ile ja Isikuandmete kaitse seadusele. Sellistel juhtudel sõlmivad pooled eraldi Andmetöötluslepingu (DPA).' },
      { num: '7.5', text: 'Klient vastutab isikuandmete edastamise seaduslikkuse eest ja hüvitab kahju, kui nende edastamine või töötlemine osutus ebaseaduslikuks.' },
      { num: '7.6', text: 'Täitja rakendab mõistlikke tehnilisi ja organisatsioonilisi kaitsemeetmeid, kuid ei vastuta Kliendi või kolmandate osapoolte infrastruktuurist põhjustatud intsidentide eest.' }
    ]
  },
  
  liability: {
    title: '8. Maksed, tagasimaksed ja vastutus',
    isHighRisk: true,
    content: [
      { num: '8.1', text: 'Kõik maksed on tagastamatud, välja arvatud juhul, kui Täitja ei ole alustanud teenuste osutamist 30 päeva jooksul mõjuva põhjuseta või on toime pannud olulise rikkumise, mida ei ole parandatud 15 päeva jooksul pärast Kliendi teavitust.' },
      { num: '8.2', text: 'Teenuste eest tasumine tähendab Kliendi täielikku nõustumist käesolevate Tingimustega. Pärast teenuste osutamise alustamist ei lubata tagasimakseid ega ümberarvutusi.' },
      { num: '8.3', text: 'Projekti ühepoolsel lõpetamisel Kliendi poolt on Täitjal õigus kõik saadud maksed alles jätta.' },
      { num: '8.4', text: 'Täitjal on õigus teenuste osutamine peatada või lõpetada maksete tähtaegade või Lepingu tingimuste rikkumisel.' },
      { num: '8.5', text: 'Täitja ei vastuta kaudsete kahjude, saamata jäänud kasumi, andmete kadumise või mainega seotud kahjude eest.' },
      { num: '8.6', text: 'Täitja vastutus võib tekkida ainult tahtluse või raske hooletuse korral.' },
      { num: '8.7', text: 'Täitja koguvastutus on piiratud summaga € 1 000, sõltumata nõude alusest.', amount: '€ 1 000' },
      { num: '8.8', text: 'Klient kinnitab, et ei esita nõudeid, mis põhinevad ootustel või subjektiivsel hinnangul tulemustele.' },
      { num: '8.9', text: 'Klient hüvitab Täitjale kõik nõuded, kahjud või trahvid, mis on põhjustatud Kliendi andmete või materjalide ebaseadusliku kasutamise tõttu.' }
    ]
  },
  
  termination: {
    title: '9. Kehtivusaeg, lõpetamine ja tagajärjed',
    content: [
      { num: '9.1', text: 'Leping kehtib alates allkirjastamise või arve tasumise hetkest kuni teenuste lõpetamiseni.' },
      { num: '9.2', text: 'Kumbki pool võib Lepingu lõpetada, teavitades teist poolt 30 päeva ette, kui teine pool rikub olulisi kohustusi ega kõrvalda rikkumist 15 päeva jooksul.' },
      { num: '9.3', text: 'Pärast arve tasumist ei võeta vastu tagasimakseid ega tühistamisi, välja arvatud punktis 8.1 ettenähtud juhtudel.' },
      { num: '9.4', text: 'Lõpetamisel kuuluvad kõik tasumata summad kohesele tasumisele.' },
      { num: '9.5', text: 'Täitjal on õigus Leping viivitamatult lõpetada, kui makse viibib rohkem kui 15 päeva.' },
      { num: '9.6', text: 'Sätted §§ 3.3–3.4, 4, 6, 7, 8, 9.6, 10–12 jäävad kehtima pärast Lepingu lõppemist.' }
    ]
  },
  
  forceMajeure: {
    title: '10. Vääramatu jõud',
    content: [
      { num: '10.1', text: 'Pooled vabastatakse vastutusest kohustuste mittetäitmise eest vääramatu jõu tõttu (looduskatastroofid, sõjad, kübberrünnakud, AI pakkujate tõrked, sanktsioonid, elektrikatkestused jne).' },
      { num: '10.2', text: 'Vääramatu jõu mõju all olev pool peab viivitamatult teavitama teist poolt.' },
      { num: '10.3', text: 'Kui vääramatu jõud kestab rohkem kui 60 päeva, võib kumbki pool Lepingu kirjalikult lõpetada.' }
    ]
  },
  
  disputes: {
    title: '11. Vaidluste lahendamine ja kohaldatav õigus',
    content: [
      { num: '11.1', text: 'Vaidlused lahendatakse läbirääkimiste teel.' },
      { num: '11.2', text: 'Kokkuleppe saavutamata jätmisel kuulub vaidlus arutamisele Harju Maakohtus, Eestis.' },
      { num: '11.3', text: 'Lepingule ja käesolevatele Tingimustele kohaldatakse Eesti Vabariigi seadusandlust. ÜRO rahvusvahelise kaubanduse konventsiooni (CISG) ei kohaldata.' }
    ]
  },
  
  other: {
    title: '12. Muud sätted',
    content: [
      { num: '12.1', text: 'Kliendil ei ole õigust Lepingust tulenevaid õigusi ja kohustusi üle anda ilma Täitja kirjaliku nõusolekuta.' },
      { num: '12.2', text: 'Ühest sättest loobumine ei tähenda teistest loobumist.' },
      { num: '12.3', text: 'Üksiku punkti kehvetus ei mõjuta teiste kehtivust.' },
      { num: '12.4', text: 'Elektroonilised allkirjad ja skannid (sealhulgas e-allkiri) võrdsustuvad käsitsi kirjutatud allkirjadega.' },
      { num: '12.5', text: 'E-posti teel saadetud teatised loetakse järgmisel tööpäeval kättesaaduks.' },
      { num: '12.6', text: 'Pooled kinnitavad sanktsioonide, ekspordi ja rahapesu tõkestamise seadusandluse järgimist.' },
      { num: '12.7', text: 'Klient kohustub mitte palkama Täitja töötajaid või töövõtjaid 6 kuu jooksul pärast teenuste lõpetamist; trahv — € 10 000.', penalty: '€ 10 000' },
      { num: '12.8', text: 'Täitja ei ole juriidiline ega finantsfirma; kõik konsultatsioonid on informatsioonilis-analüütilise iseloomuga ega kujuta endast õigus- ega investeerimisnõu.' }
    ]
  },
  
  importantNotice: 'Arve tasumise või Lepingu allkirjastamisega kinnitab Klient, et on Tingimustega tutvunud ja nõustub nendega täielikult. Käesolevaid Tingimusi kohaldatakse üksnes B2B tehingutele juriidiliste isikute ja/või FIE-de vahel.'
};
